<div class="smooth-scrolling without-sub-header">

  <!-- returns and refund detail start -->

  <section class="returns-and-refund-detail p-80">
    <div class="mx-1485">
      <div class="row">
        <div class="col-lg-5">
          <div class="main-title">
            <h3 class="text-gradient">Cancellation and Return Policy</h3>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="returns-and-refund-content">
            <span>We want you to be completely satisfied with your purchase from ecommerce. If for any reason you are
              not satisfied, we offer a simple, easy and free return policy. To ensure clarity and prevent any
              confusion, please review the eligibility criteria outlined below:</span>
            <span>
              <ul>
                <li>Only products purchased directly from our website, www.ecommerceforyou.com, are eligible for
                  return.</li>
                <li>Products must be unused, unopened, and in their original packaging.</li>
                <li>Return requests must be initiated within 10 days from the date of delivery.</li>
                <li>You are eligible to return a part of your order too, i.e., out of ‘n’ products in your order,
                  you can choose to return one, some or all of them.</li>
              </ul>
            </span>
            <span>As a brand committed to prioritizing our customers, we kindly request your understanding
              regarding returns. While we strive to provide the best experience, excessive returns may incur
              added charges. We value your satisfaction and aim to work together to ensure a positive
              shopping experience for everyone involved.</span>
            <span>If you have any concerns regarding your return, please reach out to us at <a
                href="#">customer@ecommerce.com</a>.</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="tabs-detail r-tab-none">
    <div class="mx-1485">
      <div class="tab-bg">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link c-purple active" id="cancellation-tab" data-bs-toggle="tab"
              data-bs-target="#cancellation" type="button" role="tab" aria-selected="false">Cancellation</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link c-pink" id="return-tab" data-bs-toggle="tab" data-bs-target="#return" type="button"
              role="tab" aria-selected="true">Return</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link c-orange" id="exchange-tab" data-bs-toggle="tab" data-bs-target="#exchange"
              type="button" role="tab" aria-selected="false">Exchange</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link c-pink" id="refund-tab" data-bs-toggle="tab" data-bs-target="#refund" type="button"
              role="tab" aria-selected="false">Refund</button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="cancellation" role="tabpanel">
            <div class="tabbing-content">
              <div class="row">
                <div class="col-lg-8">
                  <ul>
                    <li>If you want to cancel some or all items in your order, you can only do it before the
                      shipping is completed. To proceed with cancellation, tap on the order to be cancelled
                      and you will see a cancellation option. Select the reason of cancellation and you’re done.</li>
                    <li>There’s no way of cancelling the order once the shipping is completed. However, if you
                      want to cancel the items after shipping, please refuse the delivery; your order will be
                      automatically cancelled.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="return" role="tabpanel">
            <div class="tabbing-content">
              <div class="row">
                <div class="col-lg-8">
                  <ul>
                    <li>To initiate a return, go to orders. Select the order you want to return. You will see an
                      option for return/exchange. Just click on return, select the reason, attach supporting
                      media (if asked) and proceed.
                    </li>
                    <li>Please ensure the product is unused and securely packed with original price tags,
                      labels, freebies and other accessories. Otherwise, your pickup might be denied by our
                      pickup partner.</li>
                    <li>You will be informed about the details of your pick up through your e-mail address and
                      contact number.</li>
                    <li>Gift cards, promotional items, or free products received with your purchase are
                      non-returnable.
                    </li>
                    <li>Due to hygiene issues, personal care tools are non-returnable.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="exchange" role="tabpanel">
            <div class="tabbing-content">
              <div class="row">
                <div class="col-lg-8">
                  <ul>
                    <li>We go the extra mile to make sure that the products are the right fit for you and reach at
                      your doorstep safely and securely. However, in cases where the product is damaged,
                      poorly packed, of poor quality or expired, please select exchange when you click the
                      order. Select the reason for exchange and proceed.</li>
                    <li>Please ensure the product is unused and securely packed with original price tags,
                      labels, freebies and other accessories. Otherwise, your pickup might be denied by our
                      pickup partner.</li>
                    <li>Once we receive and verify the exchange request, you will be informed about the details
                      of the pickup and delivery through your e-mail address and contact number.</li>
                    <li>Please note that the exchange is subject to the availability of products. In case the stock
                      doesn’t allow for an exchange, you will receive a full refund.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="refund" role="tabpanel">
            <div class="tabbing-content">
              <div class="row">
                <div class="col-lg-8">
                  <ul>
                    <li>In case of cancellation before shipping, your refund will be processed to your source
                      account within 2-7 business days of receiving the cancellation request.</li>
                    <li>In case of a return or a refusal of delivery, your refund will be processed to your source
                      account within 2-7 business days of receiving the products.</li>
                    <li>For cash on delivery orders, refund will be processed through bank transfer as per the
                      billing details shared by you, within 2-7 business days of receiving back the product.</li>
                    <li>Once we receive the returned/refused product and verify its eligibility, we will process
                      your refund.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="tab-detail accordian-detail">
    <div class="mx-1485">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button c-purple" type="button" data-bs-toggle="collapse"
              data-bs-target="#cancellation" aria-expanded="true" aria-controls="cancellation">Cancellation</button>
          </h2>
          <div id="cancellation" class="accordion-collapse collapsed show" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div class="tabbing-content">
                <div class="row">
                  <div class="col-lg-8">
                    <ul>
                      <li>If you want to cancel some or all items in your order, you can only do it before the
                        shipping is completed. To proceed with cancellation, tap on the order to be cancelled
                        and you will see a cancellation option. Select the reason of cancellation and you’re done.</li>
                      <li>There’s no way of cancelling the order once the shipping is completed. However, if you
                        want to cancel the items after shipping, please refuse the delivery; your order will be
                        automatically cancelled.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button class="accordion-button collapsed c-orange" type="button" data-bs-toggle="collapse"
              data-bs-target="#return" aria-expanded="false" aria-controls="return">Return</button>
          </h2>
          <div id="return" class="accordion-collapse collapse" aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div class="tabbing-content">
                <div class="row">
                  <div class="col-lg-8">
                    <ul>
                      <li>To initiate a return, go to orders. Select the order you want to return. You will see an
                        option for return/exchange. Just click on return, select the reason, attach supporting
                        media (if asked) and proceed.
                      </li>
                      <li>Please ensure the product is unused and securely packed with original price tags,
                        labels, freebies and other accessories. Otherwise, your pickup might be denied by our
                        pickup partner.</li>
                      <li>You will be informed about the details of your pick up through your e-mail address and
                        contact number.</li>
                      <li>Gift cards, promotional items, or free products received with your purchase are
                        non-returnable.
                      </li>
                      <li>Due to hygiene issues, personal care tools are non-returnable.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button class="accordion-button collapsed c-pink" type="button" data-bs-toggle="collapse"
              data-bs-target="#exchange" aria-expanded="false" aria-controls="exchange">Exchange</button>
          </h2>
          <div id="exchange" class="accordion-collapse collapse" aria-labelledby="headingThree"
            data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div class="tabbing-content">
                <div class="row">
                  <div class="col-lg-8">
                    <ul>
                      <li>We go the extra mile to make sure that the products are the right fit for you and reach at
                        your doorstep safely and securely. However, in cases where the product is damaged,
                        poorly packed, of poor quality or expired, please select exchange when you click the
                        order. Select the reason for exchange and proceed.</li>
                      <li>Please ensure the product is unused and securely packed with original price tags,
                        labels, freebies and other accessories. Otherwise, your pickup might be denied by our
                        pickup partner.</li>
                      <li>Once we receive and verify the exchange request, you will be informed about the details
                        of the pickup and delivery through your e-mail address and contact number.</li>
                      <li>Please note that the exchange is subject to the availability of products. In case the stock
                        doesn’t allow for an exchange, you will receive a full refund.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFour">
            <button class="accordion-button collapsed c-pink" type="button" data-bs-toggle="collapse"
              data-bs-target="#refund" aria-expanded="false" aria-controls="refund">Refund</button>
          </h2>
          <div id="refund" class="accordion-collapse collapse" aria-labelledby="headingFour"
            data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div class="tabbing-content">
                <div class="row">
                  <div class="col-lg-8">
                    <ul>
                      <li>In case of cancellation before shipping, your refund will be processed to your source
                        account within 2-7 business days of receiving the cancellation request.</li>
                      <li>In case of a return or a refusal of delivery, your refund will be processed to your source
                        account within 2-7 business days of receiving the products.</li>
                      <li>For cash on delivery orders, refund will be processed through bank transfer as per the
                        billing details shared by you, within 2-7 business days of receiving back the product.</li>
                      <li>Once we receive the returned/refused product and verify its eligibility, we will process
                        your refund.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="returns-and-refund-detail p-80">
    <div class="mx-1485 py-4">
      <div class="returns-and-refund-content">
        <span>Please note that this return policy is subject to change without prior notice. It is your
          responsibility to review the policy before making a purchase. If you have any questions or need
          further assistance, please contact our customer service team at <a href="#">customer@ecommerce.com</a> We will be prompt to assist you.
          Happy Discoveries!</span>
      </div>
    </div>
  </section>

  <!-- returns and refund detail end -->
</div>
<!-- Footer START -->
<app-footer-bg></app-footer-bg>
<!-- Footer END -->